const Eclipse = ({ InnerColor = "#12B76A", OuterColor = "#D1FADF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <circle cx="7" cy="7" r="7" fill={OuterColor} />
    <circle cx="7" cy="7" r="3" fill={InnerColor} />
  </svg>
);

export default Eclipse;
